export class Placeholder {
  name: string; // name of the file to use while uploading
  label: string;  // label to show on the file
  icon: string; // can be material icon or url of a file
  imageUrl: string;
}
